import { Action } from 'store/store';
import {
    ApiErrorResponseInfo,
    ApiRequestInfo,
    ApiResponseInfo,
} from 'communication/ApiCallInfo';

export enum RequestProgressActionType {
    REQUEST_PROGRESS_SET_IN_PROGRESS = 'REQUEST_PROGRESS_SET_IN_PROGRESS',
    REQUEST_PROGRESS_SET_ERROR = 'REQUEST_PROGRESS_SET_ERROR',
    REQUEST_PROGRESS_SET_SUCCESS = 'REQUEST_PROGRESS_SET_RESULT_SUCCESS',
    REQUEST_PROGRESS_ADD_REQUEST = 'REQUEST_PROGRESS_ADD_REQUEST',
    REQUEST_PROGRESS_ADD_RESPONSE = 'REQUEST_PROGRESS_ADD_RESPONSE',
}

export interface RequestProgressActionPayload {
    key: string;
}

export type RequestProgressInProgressAction = Action<
    RequestProgressActionType.REQUEST_PROGRESS_SET_IN_PROGRESS,
    RequestProgressActionPayload
>;

export const requestProgressInProgressAction: (
    key: string
) => RequestProgressInProgressAction = (key) => ({
    type: RequestProgressActionType.REQUEST_PROGRESS_SET_IN_PROGRESS,
    payload: { key },
});

export interface RequestProgressActionPayload {
    key: string;
}

export interface RequestProgressAddRequestActionPayload {
    key: string;
    requestInfo: ApiRequestInfo;
}

export type RequestProgressAddRequestAction = Action<
    RequestProgressActionType.REQUEST_PROGRESS_ADD_REQUEST,
    RequestProgressAddRequestActionPayload
>;

export const requestProgressAddRequest: (
    key: string,
    requestInfo: ApiRequestInfo
) => RequestProgressAddRequestAction = (key, requestInfo) => ({
    type: RequestProgressActionType.REQUEST_PROGRESS_ADD_REQUEST,
    payload: { key, requestInfo },
});

export interface RequestProgressAddResponseActionPayload {
    key: string;
    requestId: string;
    responseInfo: ApiResponseInfo | ApiErrorResponseInfo;
}

export type RequestProgressAddResponseAction = Action<
    RequestProgressActionType.REQUEST_PROGRESS_ADD_RESPONSE,
    RequestProgressAddResponseActionPayload
>;

export const requestProgressAddResponse: (
    key: string,
    requestId: string,
    responseInfo: ApiResponseInfo | ApiErrorResponseInfo
) => RequestProgressAddResponseAction = (key, requestId, responseInfo) => ({
    type: RequestProgressActionType.REQUEST_PROGRESS_ADD_RESPONSE,
    payload: { key, requestId, responseInfo },
});

export type RequestProgressSuccessAction = Action<
    RequestProgressActionType.REQUEST_PROGRESS_SET_SUCCESS,
    RequestProgressActionPayload
>;

export const requestProgressSuccessAction: (
    key: string
) => RequestProgressSuccessAction = (key) => ({
    type: RequestProgressActionType.REQUEST_PROGRESS_SET_SUCCESS,
    payload: { key },
});

export interface RequestProgressErrorActionPayload
    extends RequestProgressActionPayload {
    message: string;
    statusCode?: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data?: any;
}

export type RequestProgressErrorAction = Action<
    RequestProgressActionType.REQUEST_PROGRESS_SET_ERROR,
    RequestProgressErrorActionPayload
>;

export const requestProgressErrorAction: (
    key: string,
    message: string,
    statusCode?: number,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data?: any
) => RequestProgressErrorAction = (key, message, statusCode, data) => ({
    type: RequestProgressActionType.REQUEST_PROGRESS_SET_ERROR,
    payload: { key, statusCode, message, data },
});

export type RequestProgressAction =
    | RequestProgressInProgressAction
    | RequestProgressErrorAction
    | RequestProgressSuccessAction
    | RequestProgressAddResponseAction
    | RequestProgressAddRequestAction;
